import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { CheckCircle, Truck, CreditCard, Headphones } from "lucide-react";
import { useTranslation } from "react-i18next";
import onasPhoto from "@/assets/onas-photo.jpg";
import SEOHead from "@/components/SEOHead";

const icons = [Headphones, Truck, CreditCard, CheckCircle];

const ONas = () => {
  const { t } = useTranslation();
  const advantages = t("aboutPage.advantages", { returnObjects: true }) as string[];

  return (
    <Layout>
      <SEOHead
        title="O nas – producent naklejek 3D wypukłych doming"
        description="Poznaj producenta naklejek 3D wypukłych zalewanych żywicą poliuretanową. Produkcja na zamówienie dla firm w Polsce i UE. Sprawdź nasze możliwości i wyceń online."
      />
      <section className="gradient-navy py-20 lg:py-28">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl lg:text-5xl font-bold text-primary-foreground mb-4">
            {t("aboutPage.title")}<span className="text-gradient-gold">{t("aboutPage.titleGold")}</span>
          </h1>
          <p className="text-primary-foreground/80 text-lg max-w-2xl mx-auto">{t("aboutPage.subtitle")}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-5xl mx-auto">
            <div>
              <h2 className="text-3xl font-bold text-foreground mb-6">{t("aboutPage.historyTitle")}</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">{t("aboutPage.historyP1")}</p>
              <p className="text-muted-foreground leading-relaxed mb-8">{t("aboutPage.historyP2")}</p>
              <div className="space-y-4">
                {advantages.map((text, i) => {
                  const Icon = icons[i];
                  return (
                    <div key={i} className="flex items-start gap-3">
                      <Icon className="w-5 h-5 text-accent mt-0.5 shrink-0" />
                      <p className="text-foreground">{text}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              <img src={onasPhoto} alt="Naklejki 3D wypukle.pl zalewane żywicą" className="rounded-2xl shadow-lg w-full" loading="lazy" />
            </div>
          </div>

        </div>
      </section>
    </Layout>
  );
};

export default ONas;
